import axios from 'axios';

const userApi = {
  async getUser() {
    const url = '/api/user';
    const response = await axios.get(url);
    return response.data.response
  },
}

export default userApi;
